import { RouteComponentProps } from "react-router";
import { Route, Switch } from "react-router-dom";
import { useHasInvoicePermission } from "../../hooks/useHasInvoicePermission";
import OrganizationDocumentInvoiceEditPage from "./pages/Edit";
import OrganizationDocumentInvoiceIndexPage from "./pages/Index";
import OrganizationDocumentInvoiceNewPage from "./pages/New";
import OrganizationDocumentInvoicePreviewPage from "./pages/Preview";

const OrganizationDocumentInvoicePage = (props: RouteComponentProps) => {
	const { hasPermissionsToCreateNewInvoice } = useHasInvoicePermission();

	return (
		<div className="content">
			<Switch>
				<Route path={`${props.match.url}/`} exact component={OrganizationDocumentInvoiceIndexPage} />
				{hasPermissionsToCreateNewInvoice && (
					<Route path={`${props.match.url}/new`} exact component={OrganizationDocumentInvoiceNewPage} />
				)}
				<Route
					path={`${props.match.url}/:invoiceId`}
					exact
					component={OrganizationDocumentInvoicePreviewPage}
				/>
				<Route path={`${props.match.url}/:invoiceId/edit`} component={OrganizationDocumentInvoiceEditPage} />
			</Switch>
		</div>
	);
};

export default OrganizationDocumentInvoicePage;
